import { BaseService } from "./BaseService";
import { CalendarOutput } from "@/interfaces";

export class CalendarService extends BaseService<unknown, CalendarOutput> {
  constructor() {
    super();
    this.path = "calendars";
  }
}
